import Vue from 'vue';
import { Vue as _Vue } from 'vue/types/vue';
import Vuex from 'vuex';
import { Store } from 'vuex';
import { VueModule } from 'vue-modules';
import {AuthStore, SnackbarStore} from '@/modules/core/store';
import {User} from "@/modules/core/models";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    showMenu: false,
    showBottonNavigation: false,
    loginUser: null as User,
    menus: [
      { text: 'Inicio', icon: 'mdi-home', to: { path: '/' }, active: true },
      { text: 'Register', icon: 'mdi-account-plus', to: { name: 'registro' }, active: false, auth:false},
      { text: 'Busca Socio', icon: 'mdi-account', to: { name: 'partners' }, active: true, auth:true },
      { text: 'Feedback', icon: 'mdi-lightbulb-on-outline', to: { name: 'feedback' }, active: true, auth:true},
    ],
  },
  mutations: {
    setShowMenu(state, isActive: boolean) {
      state.showMenu = isActive;
      state.showBottonNavigation = isActive;
    },
    setLoginUser(state, user: User) {
      state.loginUser = user;
    },
  },
  actions: {

  },
});

export class StoreModule implements VueModule {
  public readonly name = 'store';
  public store?: Store<any>;
  // tslint:disable-next-line: no-shadowed-variable
  public install(Vue: typeof _Vue) {
    this.store = store;
    this.store.registerModule(["snackbar"], SnackbarStore);
    this.store.registerModule(["auth"], AuthStore);
  }
}
